import { useState } from "react";
import { DatePicker, Modal } from "antd";
import { useDispatch } from "react-redux";
import { startGetSeguimientosXls } from "../../context/actions/reportesActions";

export const ModalSeguimientosXls = ({ visible, onClose }) => {
  const dispatch = useDispatch();
  const [fecha, setFecha] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleOk = async () => {
    setLoading(true);
    const result = await dispatch(startGetSeguimientosXls({
      fecha: fecha.format("YYYY-MM"),
    }));
    setLoading(false);

    if (result.code === 0) {
      setFecha(null);
      onClose();
    }
  };

  const handleCancel = () => {
    setFecha(null);
    onClose();
  };

  return (
    <Modal
      title="Reporte de Seguimientos"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okButtonProps={{ disabled: !fecha }}
    >
      <DatePicker
        value={fecha}
        style={{ width: "100%" }}
        onChange={setFecha}
        picker="month"
        format="YYYY-MM"
      />
    </Modal>
  );
};
